import { TagDTO } from '@gearbelt/global';
import { v4 as uuidv4 } from 'uuid';

import { UpdateWorkspaceEntityDialog, type UpdateWorkspaceEntityDialogConfig } from '@/components/settings/update-workspace-entity-dialog';

const tagConfig: UpdateWorkspaceEntityDialogConfig<TagDTO> = {
  title: 'Schedule Check Tags',
  description: 'Tags let you group schedule checks by custom labels. You can reorder them to control how they appear in the dropdown menu.',
  createEmptyItem: () => ({
    id: uuidv4(),
    tag: '',
    order: 9999,
  }),
  getValue: (item) => item.tag,
  setValue: (item, value) => ({ ...item, tag: value }),
};

function UpdateWorkspaceScheduleTags({
  scheduleTags,
  open,
  onOpenChange,
  callback,
}: {
  scheduleTags: TagDTO[] | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (tags: TagDTO[]) => void;
}) {
  return <UpdateWorkspaceEntityDialog items={scheduleTags} open={open} onOpenChange={onOpenChange} callback={callback} config={tagConfig} />;
}

export { UpdateWorkspaceScheduleTags };
